<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/highlights-library.png">
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "HLL",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8',
      userData: null,
      userData2: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      // console.log('this.userData', this.userData);
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('HLL SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/hll/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/hll/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.userData2 = response.data.user;
              // alert()
              // console.log('this.userData2', this.userData2);
              this.goHLL()
            } else if (response.data.message) {
              // success:false + message → örn. lisans/yetki reddi. Kullanıcı henüz
              // yok diye create'e düşmek yerine reddi doğrudan gösteriyoruz, çünkü
              // create de aynı kontrolden geçip aynı sebeple reddedilecek.
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/hll/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/hll/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              this.userData2 = response.data.user;
              this.goHLL()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    async goHLL() {
      // Kullanıcı verisini HLL formatına dönüştür
      // console.log('this.userData', this.userData);
      // console.log('this.userData2', this.userData2);
      const userDataHLL = this.createUserDataHLL(this.userData2);
      // console.log('userDataHLL', userDataHLL);

      // Gerekirse encrypt fonksiyonunu ekle
      this.ensureEncryptFunction();

      // HLL SSO yönlendirmesini başlat
      this.goHLLRedirect(userDataHLL);
    },

    createUserDataHLL(userData) {
      // console.log('userData', userData);
      // Öğrenci ya da öğretmen için class_name'i hazırla
      let class_name2;
      if (userData.roleType === 'student' || userData.role_type === 'student' || userData.role === 'student') {
        // class_name = `${userData.class && userData.class[0] ? (userData.class[0].grade || '') : ''}${userData.class && userData.class[0] && userData.class[0].branch ? '-' + userData.class[0].branch : ''}`;
        class_name2 = userData.class_name
      } else {
        // Daha güvenli bir kontrol yapalım
        class_name2 = [];
        if (userData.class && Array.isArray(userData.class)) {
          class_name2 = userData.class.filter(item => item && item.grade && item.branch)
            .map(item => `${item.grade}-${item.branch}`);
        }
      }
      return {
        company_code: this.userData2.hll_company_code || '',
        type: (userData.roleType === 'student' || userData.role_type === 'student') ? 'student' : 'teacher',
        user_id: userData.username,
        user_name: `${userData.first_name || ''} ${userData.last_name || ''}`.trim(),
        class_name: class_name2
      };
    },

    ensureEncryptFunction() {
      if (typeof window.encryptAES256CBC !== 'function') {
        window.encryptAES256CBC = function(text) {
          // 32 karakterlik key ve 16 karakterlik iv olmalı!
          var key = CryptoJS.enc.Utf8.parse("!chlrhdmlvkxmsj@#eoqkrsktpdy#@!!");
          var iv = CryptoJS.enc.Utf8.parse("741952hheeyy66#c");
          var encrypted = CryptoJS.AES.encrypt(text, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
          // CryptoJS zaten base64 döndürür
          return encrypted.toString();
        };
      }
    },

    goHLLRedirect(userDataHLL) {
      // console.log('userDataHLL', userDataHLL);
      // HLL protokolüne uygun objeyi hazırla
      const myObject = {
        company_code: encodeURIComponent(userDataHLL.company_code),
        type: userDataHLL.type,
        user_code: userDataHLL.user_id,
        // user_id: userDataHLL.user_id,
        // çakışma yaşanmaması için böyle bir birleştirme yaptık.
        // ueslms_user_id - ueslms_user_name
        user_id: `${this.userData2.user_id}-${this.userData2.username}`,
        user_name: encodeURIComponent(userDataHLL.user_name)
      };
      if (userDataHLL.type === 'student') {
        if (userDataHLL.class_name) {
          myObject.class_name = encodeURIComponent(userDataHLL.class_name);
        }
      } else if (userDataHLL.type === 'teacher') {
        if (userDataHLL.class_name && Array.isArray(userDataHLL.class_name)) {
          myObject.class_name = [];
          userDataHLL.class_name.forEach(item => {
            myObject.class_name.push(encodeURIComponent(item));
          });
        }
      }
      // console.log('myObject', myObject);
      let myString = JSON.stringify(myObject);
      const t = parseInt(myString.length / 16);
      if (myString.length - (t * 16) === 0) {
        myObject.except_code = "true";
        myString = JSON.stringify(myObject);
      }
      const real_text = encodeURIComponent(window.encryptAES256CBC(myString));
      // console.log('real_text', real_text);
      location.href = `https://library.highlights.com/sso/hllsso/procSso?highlights=${real_text}`;
    },
  }
}
</script>
